import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import * as styles from './CianAgency.css';
import { HonestWork } from '@cian/honestwork-component';
const logo = require('./logo.png') as string;

export const handleClickWithStopPropagation = (
  e: React.MouseEvent<HTMLDivElement>,
) => {
  e.stopPropagation();
};

export const CianAgency = () => (
  <div>
    <div
      {...mergeStyles([styles['agent'], styles['agent--premium']])}
      onClick={handleClickWithStopPropagation}
    >
      <div>
        <img
          {...mergeStyles(styles['avatar'], styles['avatar--premium'])}
          src={logo}
        />
        <div className={styles['badge-container']}>
          <div
            onClick={handleClickWithStopPropagation}
            className={styles['badge']}
          >
            <HonestWork />
          </div>
        </div>
        <div className={styles['name']}>Эксклюзивно от Циан</div>
      </div>
    </div>
  </div>
);
